import { extractDateAndNameFromColumnKey } from './create-column-keys'
import { Entity } from './types'

export const headerCellsProps = {
  [Entity.Title]: { alignLeft: true, rowSpan: 2 },
  [Entity.TitleGhost]: { alignLeft: true, width: 0, stripPadding: true },
  [Entity.Total]: { alignCenter: true, colSpan: 2 },
  [Entity.TotalCount]: { alignCenter: true },
  [Entity.TotalSum]: { alignCenter: true },
  [Entity.Date]: { alignCenter: true, colSpan: 2, borderRight: true },
  [Entity.DateCount]: { alignCenter: true, minWidth: 90 },
  [Entity.DateSum]: { alignCenter: true, minWidth: 90, borderRight: true },
}

export const createHeaderCellsProps = ({
  firstColumnWidht,
  lastColumnWidth,
}: {
  firstColumnWidht?: number
  lastColumnWidth?: number
} = {}) => {
  return new Proxy(headerCellsProps, {
    get: function (target, property) {
      if (property === Entity.Title && firstColumnWidht)
        return { ...target[Entity.Title], width: firstColumnWidht }
      if (property === Entity.Total && lastColumnWidth)
        return { ...target[Entity.Total], width: lastColumnWidth }
      const res = target[property as string]
      if (!res) {
        const [name] = extractDateAndNameFromColumnKey(property as string)
        return target[name] || ''
      }
      return res || {}
    },
  })
}
